import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import { ISettingsGroup } from '../Interfaces/ISettingsGroup';

const SettingsGroup = (props: ISettingsGroup) => {
  const tiles = Array.isArray(props.children)
    ? props.children
    : [props.children];
  return (
    <div>
      <Typography variant="h2">{props.title}</Typography>
      <Grid container direction="row" spacing={3}>
        {tiles
          .filter(x => x)
          .map((tile, i) => {
            return (
              <Grid item key={i}>
                {tile}
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default SettingsGroup;
